interface Components {
  [key: string]: any;
}
const requireModules = require.context('./contents/', true, /\.vue$/);
export const toolTipComponents: Components = {};
requireModules.keys().map((fileName: string) => {
  const name = fileName.slice(fileName.lastIndexOf('/') + 1, fileName.length - 4);
  toolTipComponents[name] = () => import(`@/pro/components/common/tooltip/contents/${fileName.slice(2)}`);
});
